import { render, staticRenderFns } from "./first_submission_time_vs_final_score.vue?vue&type=template&id=5f1d7c90&scoped=true&"
import script from "./first_submission_time_vs_final_score.vue?vue&type=script&lang=ts&"
export * from "./first_submission_time_vs_final_score.vue?vue&type=script&lang=ts&"
import style0 from "./first_submission_time_vs_final_score.vue?vue&type=style&index=0&id=5f1d7c90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d7c90",
  null
  
)

export default component.exports